import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, PopoverController, ToastController } from '@ionic/angular';
import { CalendarModalOptions } from 'ion2-calendar';
import { InViewportMetadata } from 'ng-in-viewport';
import { ServicesProvider } from 'src/providers/services';
import { AdvanceFilterPage } from '../advance-filter/advance-filter.page';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { MediapopupPage } from '../mediapopup/mediapopup.page';
import { PhysioProgramPage } from './physio-program/physio-program.page';
import { IonContent } from "@ionic/angular";
import { AddmemPage } from './../addmem/addmem.page';
import { ReviewPage } from '../review/review.page';
import { ViewmodelPage } from '../viewmodel/viewmodel.page';
import { VideoCallService } from 'src/providers/videocall';
import { CommonService } from 'src/providers/common';
import { Payment } from 'src/providers/payment';
import { AddCall } from 'src/providers/addvCall';
//import { ActionSheetController } from '@ionic/angular';
import { RatingSortpagePage } from 'src/app/rating-sortpage/rating-sortpage.page';
import { VcPermissionPagePage } from '../vc-permission-page/vc-permission-page.page';
import * as $ from 'jquery';
import { log } from 'console';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { HttpClient, HttpParams } from '@angular/common/http';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}
//import { ConsoleReporter } from 'jasmine';

@Component({
  selector: 'app-newphysiotherapy',
  templateUrl: './newphysiotherapy.page.html',
  styleUrls: ['./newphysiotherapy.page.scss'],
})
export class NewphysiotherapyPage implements OnInit {
  private common = CommonService;
  @Input() showTypeofBooking; @Input() typeid
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChildren('newVdo') vdoPlayer: QueryList<ElementRef>;
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  currentPlaying = null;
  isShow: any;
  specialityId: any;
  specialityName: any;
  SpecialityList: any;
  nextCount: number;
  backValue: string;
  headerValue: any;
  curntDate: string;
  presentView: string;
  genderStatus: boolean = true;
  genderContent: string = null;
  searchDate: any;
  isConfirmed : boolean
  advanceFilterStatus: boolean = false;
  advanceFilterCost: any = 0;
  advanceFilterOffers: any = 0;
  advanceFilterDistance: any = 0;
  pageNo: any = 1;
  searchStatus: boolean = false;
  SearchContent: String = "";
  EmptyData: any;
  videoOptions: any = [];
  storePhysiotherapyDocList: any = [];
  count: number = 0;
  dblClikedIndex: any;
  likedPopUpStatus: boolean;
  Date: any = new Date();
  Male: boolean = false;
  Female: boolean = false;
  selectedDate: any;
  showVideoOptins: any;
  playVid: any;
  physioPrgrmList: any = [];
  year: string;
  month: string;
  day: string;
  optionsMulti: CalendarModalOptions;
  showOfferCardPage: boolean;
  showCalenderPage: any;
  particularPhysioDocDetails: any;
  storeDocterId: any;
  storeClinicId: any;
  storeDocName: any;
  storeDocGender: any;
  storeDocAge: any;
  storeDocAdd: any;
  storeDocExp: any;
  storeDocProImg: any;
  storeDocNofRating: number;
  storeDocNofReviews: any;
  storeDocLikePercent: number;
  storeDocServiceList: any;
  selectedService: string;
  calenderMode: string = "single";
  disabelDay: any = [];
  dateRange: {
    from: Date;
    to: Date
  }
  storeToDate: any;
  storeFromDate: any;
  patientBasicDetails: any;
  patientmemberDetails: any;
  slctdMemVal: any;
  currentMemberId: string;
  BkgConPatientName: any;
  storeDocBookingList: any = [];
  historyList: any = [];
  particularBkgDetails: any;
  myFromDate: Date;
  myToDate: Date;
  chkCrnDate: Date;
  crnDate: any;
  crnYear: any;
  crnMonth: any;
  remaingDates: any = 0;
  compday: any = 0;
  storeDates: any = [];
  storeRescheduleDate: any = [];
  storeRescheduleAltDate: any = [];
  displayMonth: Date;
  getBtwDayslist: { totalDays: any; reminingDays: any; completedday: any };
  storeBookingId: any;
  storeBookingAmnt: any;
  ReSchBtnValue: string;
  storeTimeSlots: any;
  storeSelectedSlot: any;
  getReviewPopUp: boolean;
  setRevDocImg: any;
  setRevDocName: any;
  setRevDocId: any;
  getStrRating: any;
  getRemark: any;
  showbook: boolean;
  revArr: any = [];
  reviewpercenage: any;
  timeslots: any;
  slotindex: any;
  frmtime: any;
  totime: any;
  packageid: any;
  selecteddates: any = [];
  startday: any;
  endday: any;
  profileMediaDetails: any = [];
  mediaReq: any;
  scenter: any;
  packagetype: any;
  doctorid: any;
  selectedprogram: any;
  programname: any;
  program_selected: any;
  dealoption: any;
  dealType: any;
  dealvalue: any;
  finalPay: any;
  totalAmount: any;
  storedetails: any
  showreschedulrdate: any;
  tobeshowreschedulrdate: any;
  showslt_dates: any = [];
  frombdate: any;
  tobdata: any;
  SearchCat: String = "";
  mklike: any;
  program: any;
  backflrepeat: boolean;
  Like: any;
  likestatus: any;
  Docselfdec: any;
  Docproindex: any;
  dealserviceid: any;
  clinic_id: any;
  location_id: any;
  scrollEvent: any;
  getphysiolist: any;
  Email: any;
  Phoneno: any;
  paymentid: any;
  tymVal: any;
  ratingSorting: boolean;
  ratingBasedSortingOrder: any;
  distanceBasedSorting: boolean = false;
  distanceBasecSortingOrder: any = 'ASC';
  showformated_date: any;
  referenceid: any;
  storedPath: null;
  terms_and_condition_file: any;

  constructor(
    private services: ServicesProvider,
    public router: Router,
    public alertCtrl: AlertController,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public modalCtrl: ModalController,
    private datePipe: DatePipe,
    public popoverController: PopoverController,
    private videocall: VideoCallService,
    private payment: Payment,
    private addCall: AddCall,
    private file: File,
    private fileOpener: FileOpener,
    private httpClient: HttpClient,
    //private actionsheet : ActionSheetController,
  ) { }

  option = {
    percent: 75,
    maxPercent: 100,
    startFromZero: false,
    radius: 20,
    outerStrokeWidth: 3,
    outerStrokeColor: 'var(--app-theme)',
    animation: true,
    animationDuration: 500,
    showInnerStroke: false,
    space: -13,
    backgroundStrokeWidth: 3,
    backgroundStroke: '#e8e8e8',
    backgroundPadding: -2,
    showSubtitle: false,
    showUnits: false,
    showTitle: false,
    clockwise: true
  }

  option1 = {
    percent: 75,
    maxPercent: 100,
    startFromZero: false,
    radius: 20,
    outerStrokeWidth: 3,
    outerStrokeColor: 'var(--app-theme)',
    animation: true,
    animationDuration: 500,
    showInnerStroke: false,
    space: -13,
    backgroundStrokeWidth: 3,
    backgroundStroke: '#e8e8e8',
    backgroundPadding: -2,
    showSubtitle: false,
    showUnits: false,
    showTitle: false,
    clockwise: true
  }

  ngOnInit() {
    this.storePhysiotherapyDocList = [];
    let date = new Date();
    let day = date.toLocaleString('en-us', { weekday: 'long' });
    // console.log(day);
    let curntDate = new Date();
    let StrcurntDate = String(curntDate).split(" ");
    this.year = StrcurntDate[3];
    this.month = StrcurntDate[1];
    this.day = day;
    this.optionsMulti = {
      pickMode: "single",//this.calenderMode,
      // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
      disableWeeks: [0, 6]//this.disabelDay,

    };

    this.videoOptions = [{
      playMode: false,
      muteMode: false,
    }];

    this.physioPrgrmList = [{
      dealId: null,
      dealName: null,
      dealOption: null,
      dealValue: null,
      packageId: 419,
      trcr_cost: 500,
      trcr_package_details: "Testing Package",
      trcr_package_from: null,
      trcr_package_name: "Test",
      trcr_package_to: null,
      trcr_reschedule: 1,
      trcr_session: 23,
      trcr_tainingcategory_id: 1,
      trcr_training_id: 23
    }];

  }
  commonheadervalue : any;
  ngOnChanges() {
    console.log(this.typeid,'from booking',this.showTypeofBooking);
    
    this.commonheadervalue = "commonbooking"
    // create header using child_id
    console.log( this.showTypeofBooking);
    if (this.showTypeofBooking == "booking" || this.showTypeofBooking == "") {
     
    }
    else if (this.showTypeofBooking == "booking hitory") {
       
    }
   
   
    }


  //---------\/--------PreDefine Function's---------\/---------------//
  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  async presentModal() {
    const modal = await this.modalCtrl.create({
      component: AdvanceFilterPage,
      cssClass: 'ModelConCSS'
    });
    modal.onDidDismiss()
      .then((data) => {
        const response = data;
        //  console.log(response);
        if (response.data != null) {
          console.log(response.data);
          this.advanceFilterStatus = true;
          this.advanceFilterCost = response.data.costValue;
          this.advanceFilterOffers = response.data.offers;
          this.advanceFilterDistance = response.data.distance;
          this.searchDate = response.data.selectedDate
          //  console.log(response.data.selectedDate);
          let date = new Date(this.searchDate);
          //  console.log("serachDate=>", date);
          this.Date = date;
          this.pageNo = 1;
          this.EmptyData = null;
          this.showListPhysiotherapy(this.specialityId, this.specialityName);
        }
      });
    return await modal.present();
  }

  async openDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': this.selectedDate,
        'calenderType': "docList"    //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data) {
          // this.selectedDate = data.data;
          //this.searchDate = data.data.toISOString().split("T")[0];
          this.Date = data.data
          this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
          this.pageNo = 1;
          this.EmptyData = null;
          //  console.log(this.searchDate);
          this.storePhysiotherapyDocList = [];
          this.showListPhysiotherapy(this.specialityId, this.specialityName);
        }
        //  console.log("selectedDate=>", this.searchDate);
      });
  }



  

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    var Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        var hourEnd = Value.indexOf(":");
        var H = +String(Value).substr(0, hourEnd);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? "AM" : "PM";
        // var ampm = (H < 12 || H === 24) ? this.addCall.title458 : this.addCall.title459;
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else {
          let dateCall = new Date(dateTime);
          var months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          var days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
          var arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear();
          return arDate;
        }
      case "Date2":
        return this.datepipeTransform(new Date(dateTime), "dd MMM");
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  async offrDtils(myEvent, deal, item, flow, i) {
    //  console.log(item,"details",flow,'flow');
    //  console.log(deal)
    let popover = await this.popoverController.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        dealdetails: deal,
        from: "physiotherapy"
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss()
      .then((data) => {
        console.log(data)
        if (data.data == undefined) {
          //  console.log("stay")
        }
        else {
          let dealid = data.data.dataforphysio.deal_service_type_id;



          this.showphysiotherapyPro(item, flow, i, dealid);

          //console.log(this.particularPhysioDocDetails.manage_package)
        }
      })
    return await popover.present();
  }

  async cancelBkng(bookingId, bookingAmnt) {
    this.storeBookingId = bookingId;
    this.storeBookingAmnt = bookingAmnt;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        //  console.log(res);
        if (res.data != null) {
          console.log(res.data);
          // console.log("booking id=>", res.data.bookingId);
          // console.log("booking amnt=>", res.data.bookingAmnt);
          //this.presentLoading();
          this.callCancelBkgApi();
        }
      });
    return await modal.present();
  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      // duration: 5000
    });
    await loading.present();
    // console.log('Loading dismissed!');
  }

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
  }

  //---------/\--------PreDefine Function's---------/\---------------//

  //-------------\/--------SOME SPECIAL FUNCTION'S-----------\/-------------//
  refEvent: any;
  doRefresh(event, page) {
    this.refEvent = event;
    this.pageNo = 1;
    this.EmptyData = null;

    if (page == "listdocter") {
      this.storePhysiotherapyDocList = [];
      this.showListPhysiotherapy(this.specialityId, this.specialityName);
    }
    else if (page == "listBooking") {
      this.storeDocBookingList = [];
      this.showAppointmentListPage();
    }
    else if (page == 'historylistpage') {
      this.historyList = []
      this.showBookingHisListPage()
    }

    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  loadData(event, page) {
    console.log(event);
    // console.log(this.pageNo);
    event.target.disabled = true;
    this.scrollEvent = event;
    //this.pageNo = 1;
    this.pageNo += 1;
    if (page == "listdocter") {
      //  console.log("List trainig center load more");
      this.showListPhysiotherapy(this.specialityId, this.specialityName);
    }
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }


  doubleClick(count, index, docId) {
    this.count += Number(count);
    console.log(this.count);
    if (this.count == 1) {
      //   console.log("before");
      setTimeout(() => {
        this.count = 0;
        //  console.log("count reseted");
      }, 300);
    }
    // console.log("AftresetTimeOut");
    if (this.count == 2) {
      //this.like(index, docId);
      this.makeLike(index, docId, 1, 2)
      this.count = 0;
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        this.likedPopUpStatus = false;
      }, 1000)
    }

    // console.log("Count",count);
    //   console.log("index",index);
    //   console.log("id",docId);
  }

  // like(i, doctorId) {

  //   console.log("index=>", i, "doc ID=>", doctorId);
  //   if (this.storePhysiotherapyDocList[i].favourite == 'true') {
  //     this.storePhysiotherapyDocList[i].favourite = 'false';

  //   }
  //   else {
  //     this.storePhysiotherapyDocList[i].favourite = 'true';
  //   }
  //   let apiData = JSON.stringify({
  //     "doctorId": doctorId,
  //     "patientId": localStorage.getItem("patient_id"),
  //     "favourite": this.storePhysiotherapyDocList[i].favourite
  //   });
  //   console.log("send favrit Reqst=>", JSON.parse(apiData));
  //   this.services.postRequest("favouriteDoctorAddingandRemoving", apiData).subscribe(res => {
  //     console.log(res);
  //   });
  //   if (this.storePhysiotherapyDocList[i].favourite == 'true') {
  //     this.presentToast("Add to Favourite");
  //   }
  //   else if (this.storePhysiotherapyDocList[i].favourite == 'false') {
  //     this.presentToast("Removed from Favourite");
  //   }
  // }




  makeLike(i, Docid, like, from) {
    // console.log("isliked",like);

    // console.log("training centre id",Docid);
    // console.log("like",from);

    // this.storeParticulerCategoryInfo

    try {
      if (this.storePhysiotherapyDocList[i].isLiked == null) {
        this.storePhysiotherapyDocList[i].isLiked = 'true';
        this.storePhysiotherapyDocList[i].likes_count = Number(this.storePhysiotherapyDocList[i].likes_count) + 1;
      }
      if (from == 2) {
        if (this.storePhysiotherapyDocList[i].isLiked == "false") {
          this.storePhysiotherapyDocList[i].isLiked = 'true';
          this.storePhysiotherapyDocList[i].likes_count = Number(this.storePhysiotherapyDocList[i].likes_count) + 1;
        }
      } else if (from == 1) {
        if (this.storePhysiotherapyDocList[i].isLiked == "false") {
          this.storePhysiotherapyDocList[i].isLiked = 'true';
          this.storePhysiotherapyDocList[i].likes_count = Number(this.storePhysiotherapyDocList[i].likes_count) + 1;
        }
        else if (this.storePhysiotherapyDocList[i].isLiked == "true") {
          this.storePhysiotherapyDocList[i].isLiked = 'false';
          this.storePhysiotherapyDocList[i].likes_count = Number(this.storePhysiotherapyDocList[i].likes_count) - 1;
        }
      }
      let data = JSON.stringify({
        "vendor_id": Docid,
        "like": like,
        "user_id": localStorage.getItem("patient_id"),
        "module_name": "Physiotherapy"
      });
      this.services.postRequestDoc("UpdateVendorLikes", data).subscribe(res => {
        console.log(res);
      }, (err) => {
        console.log(err);
      });
    } catch (err) {
      console.log(err);
    }

  }


  makeLikeprofile(i, Docid, like, from) {
    // console.log("i",i);
    // console.log("training centre id",Docid);

    //console.log("like", this.particularCenterInfo.isLiked,"==",this.particularCenterInfo.likes_count)
    // this.storeParticulerCategoryInfo

    try {
      // if (this.storeParticulerCategoryInfo[i].isLiked == null) {
      //   this.storeParticulerCategoryInfo[i].isLiked = 1;
      //   this.storeParticulerCategoryInfo[i].likes_count = Number(this.storeParticulerCategoryInfo[i].likes_count) + 1;
      // }

      if (this.likestatus == null) {
        this.likestatus = "true";
        this.Like = Number(this.Like) + 1;
      }
      // if (from == 2) {
      //   if (this.storeParticulerCategoryInfo[i].isLiked == 0) {
      //     this.storeParticulerCategoryInfo[i].isLiked = 1;
      //     this.storeParticulerCategoryInfo[i].likes_count = Number(this.storeParticulerCategoryInfo[i].likes_count) + 1;
      //   }
      // } 
      if (from == 2) {
        if (this.likestatus == "false") {
          this.likestatus = "true";
          this.Like = Number(this.Like) + 1;
        }
      }

      else if (from == 1) {
        // this.particularTrainerDetails.isLiked = 1;
        // this.particularTrainerDetails.likes_count=Number(this.storeTrainerList[i].likes_count) + 1;

        if (this.likestatus == "false") {
          this.particularPhysioDocDetails.isLiked = "true";
          this.likestatus = "true";
          this.Like = Number(this.Like) + 1;
          // this.likestatus = 1;
          // this.Like = Number(this.Like) + 1;
        }
        else if (this.likestatus == "true") {
          this.particularPhysioDocDetails.isLiked = "false";
          this.likestatus = "false";
          this.Like = Number(this.Like) - 1;
          //   this.likestatus = 0;
          //  this.Like = Number(this.Like) - 1;
        }
      }

      // else if (from == 1) {
      //    this.particularTrainerDetails.isLiked = 1;
      //    this.particularTrainerDetails.likes_count=Number(this.storeTrainerList[i].likes_count) + 1;

      //   if (this.storeParticulerCategoryInfo[i].isLiked == 0) {
      //      this.particularCenterInfo.isLiked = 1;
      //     this.isliked = 1;
      //     this.particularCenterInfo.likes_count = Number(this.storeParticulerCategoryInfo[i].likes_count) + 1;
      //     this.storeParticulerCategoryInfo[i].isLiked = 1;
      //     this.storeParticulerCategoryInfo[i].likes_count = Number(this.storeParticulerCategoryInfo[i].likes_count) + 1;
      //   }
      //   else if (this.storeParticulerCategoryInfo[i].isLiked == 1) {
      //     this.particularCenterInfo.isLiked = 0;
      //     this.isliked = 0;
      //      this.particularCenterInfo.likes_count = Number(this.storeParticulerCategoryInfo[i].likes_count) - 1;
      //     this.storeParticulerCategoryInfo[i].isLiked = 0;
      //     this.storeParticulerCategoryInfo[i].likes_count = Number(this.storeParticulerCategoryInfo[i].likes_count) - 1;
      //   }
      // }

      if (this.mklike) {
        this.mklike.unsubscribe();
      }

      let data = JSON.stringify({
        "vendor_id": Docid,
        "like": like,
        "user_id": localStorage.getItem("patient_id"),
        "module_name": "Physiotherapy"
      });
      this.mklike = this.services.postRequestDoc("UpdateVendorLikes", data).subscribe(res => {
        console.log(res);
      }, (err) => {
        console.log(err);
      });
    } catch (err) {
      console.log(err);
    }

  }



  selctDctGndr(value) {
    console.log(typeof (value));

    this.pageNo = 1;
    this.EmptyData = null;
    switch (value) {
      case "Male": {
        //this.Male = !this.Male;
        this.Male = true;
        this.Female = false;
        if (this.Male == true) {
          this.genderStatus = true;
          this.genderContent = "male";
        }
        else {
          this.genderStatus = false;
        }
        break;
      }
      case "Female": {
        /// this.Female = !this.Female;
        this.Female = true;
        this.Male = false;
        if (this.Female == true) {
          this.genderStatus = true;
          this.genderContent = "female";
        }
        else {
          this.genderStatus = false;
        }
        break;
      }
    }
    this.showListPhysiotherapy(this.specialityId, this.specialityName);
    // console.log(this.genderStatus, "-", this.genderContent);
  }
  searchDocter() {
    this.searchStatus = true;
    this.pageNo = 1;
    this.EmptyData = null;
    this.showListPhysiotherapy(this.specialityId, this.specialityName);
    // console.log(this.searchStatus);
    // console.log(this.SearchContent);
  }

  dateIncDec(incOrDec) {
    if (incOrDec == 'inc') {
      let date = null;
      date = new Date(this.Date);
      console.log("oset=>", date);
      date.setDate(date.getDate() + 1);
      this.Date = date;
      this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
      // console.log("date", date);
      // console.log("setDate", this.Date);
      // console.log("searchDate", this.searchDate);
      this.pageNo = 1;
      this.EmptyData = null;
      this.storePhysiotherapyDocList = [];
      this.showListPhysiotherapy(this.specialityId, this.specialityName);
    }
    else if (incOrDec == 'dec') {
      if (this.Date >= new Date()) {
        let date = null;
        date = new Date(this.Date);
        console.log("oset=>", date);
        date.setDate(date.getDate() - 1);
        this.Date = date;
        this.searchDate = this.Date.getFullYear() + "-" + ("0" + (this.Date.getMonth() + 1)).slice(-2) + "-" + ("0" + this.Date.getDate()).slice(-2);
        // console.log("date", date);
        // console.log("setDate", this.Date);
        // console.log("searchDate", this.searchDate);
        this.pageNo = 1;
        this.EmptyData = null;
        this.storePhysiotherapyDocList = [];
        this.showListPhysiotherapy(this.specialityId, this.specialityName);
      }
    }
  }

  showPlyOptn(i) {
    this.showVideoOptins = i;
    setTimeout(() => {
      this.showVideoOptins = null;
    }, 5000)
  }

  playVideo(index, vdoIn, id, value) {
    console.log("passing Data=>", index, vdoIn, id, value);
    this.playVid = document.getElementById(id);
    switch (value) {
      case 'play': {
        this.playVid.play();
        //  console.log("video duration=>", this.playVid.duration);
        this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].playMode = true;
        // console.log(this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].playMode);
        break;
      }
      case 'pause': {
        this.playVid.pause();
        this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].playMode = false;
        //  console.log(this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].playMode);
        break;
      }
      case 'mute': {
        this.playVid.muted = true;
        this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].muteMode = true;
        // console.log(this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].muteMode);
        break;
      }
      case 'unMute': {
        this.playVid.muted = false;
        this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].muteMode = false;
        //console.log(this.storePhysiotherapyDocList[index].mediaDetails[vdoIn].playVideOpt[0].muteMode);
        break;
      }
    }
    // console.log(value);
    // console.log(vdoIn);
  }
  onIntersection($event, id, index, Sindex) {
    const { [InViewportMetadata]: { entry }, target } = $event;
    const ratio = entry.intersectionRatio;
    const vid = target;
    console.log(ratio)
    if ($event.visible == false) {
      //  console.log("Event", $event.target.autoplay);
      $event.target.autoplay = false;
      // console.log("Event2", $event.target.autoplay);
    }
    console.log("play Video Event=>", $event);
    if (ratio >= 0.10 && ratio <= 0.90) {
      // console.log("Play Video Details=>", id, index, Sindex);
      var playPromise = vid.play();
      //  console.log(playPromise)

      if (playPromise !== undefined) {
        playPromise.then(_ => {
          //  console.log("notError so Play");
          vid.play();
          console.log(this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode);
          this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode = true;
          this.checkVideo(id, index, Sindex);
        })
          .catch(error => {
            console.log("error so Pause");
            vid.pause();
            this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode = false;
          });
      }
    } else {
      if (this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode == true) {
        console.log("executed");
        vid.pause();
        this.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode = false;
      }
    }
    ratio >= 0.85 ? vid.play() : vid.pause();
  }

  checkVideo(id, index, Sindex) {
    var video = document.getElementById(id);
    var d = this;
    video.onended = function () {
      //this.videoFinished(id);
      console.log(d.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode);
      d.storePhysiotherapyDocList[index].mediaDetails[Sindex].playVideOpt[0].playMode = false;
    };

    console.log("Id", id);
  }

  sessions: any;
  onChange($event) {
    // console.log("=====================",$event);

    let date = new Date()
    console.log(new Date(String(date).substring(0, 16) + this.frmtime));
    let date1 = String($event._d)
    // console.log(date1);
    let checkdatetime1 = new Date(date1.substring(0, 16) + this.frmtime);
    let checkdatetime2 = new Date();
    //  console.log(checkdatetime1,"=========");
    //  console.log(checkdatetime2,"================");

    // if ( checkdatetime1 >= checkdatetime2){
    //  console.log("execute the program");
    this.scroll();
    this.showbook = true;
    if (this.calenderMode == "single" && checkdatetime1 >= checkdatetime2) {
      console.log($event);
      let dateInfo = $event;
      var item = dateInfo._d;
      let dateArray = String(item).split(" ");
      this.year = dateArray[3];
      this.month = dateArray[1];
      this.day = item.toLocaleString('en-us', { weekday: 'long' });
      console.log(dateArray[1] + "/" + dateArray[3]);

      this.autoSetToDate(this.sessions, item);
    }
    else if (checkdatetime1 <= checkdatetime2) {
      // this.AlertInfo("couldn't select the completed time for the date", 2);
      this.AlertInfo(this.addCall.title505, 2);
    }
    else {
      this.clupWorkingHr(this.working_days);
      this.calenderMode = "single";
      this.optionsMulti = {
        pickMode: this.calenderMode,
        // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
        disableWeeks: this.disabelDay,
      };
      this.dateRange = null;
    }
    //}
    // else{
    //  console.log("alart");
    //  this.AlertInfo("couldn't select the completed time for the date", 1);
    //  this.calenderMode = "single";
    //   this.optionsMulti = {
    //     pickMode: this.calenderMode,
    //     weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    //     disableWeeks: this.disabelDay,
    //   };
    //   this.dateRange = null;

    // }
  }

  showsledate: any;
  change_formated_dates: any = [];
  autoSetToDate(days, fromDate) {
    let date = null;
    //   console.log(this.disabelDay,"================<><><><><");

    this.storeToDate = null;
    let fillDate = [];
    date = new Date(fromDate);
    fillDate.push(new Date(date));
    if (days != 1) {
      //  console.log("more Session");
      for (let i = 1; i <= 1000; i++) {
        date.setDate(date.getDate() + 1);
        if (!this.disabelDay.includes(date.getDay())) {
          fillDate.push(new Date(date));
          //console.log(fillDate);
          let rangday = [];
          rangday = fillDate;
          // let date1 = new Date(date);
          // let changeformat = date1.setDate(date1.getDate() + 1)
          let d = []
          rangday.forEach(date => {
            let d1 = new Date(date)
            d.push(d1.setDate(d1.getDate() + 1))
          })
          //  console.log(d);
          let d2 = [];
          let changeformat = []
          d.forEach(date => {
            d2.push(new Date(date).toISOString().split("T")[0]);
          })
          this.selecteddates = d2;
          // console.log(on3date,"check li date")
        }
        if (fillDate.length == days) {
          this.storeToDate = fillDate[fillDate.length - 1];
          console.log("recheck", this.storeToDate)
          break;
        }
      }
      this.setRange(fromDate);
    }
    else {
      console.log("single Session");
      this.storeToDate = fillDate[fillDate.length - 1];
      this.storeFromDate = new Date(fromDate);
      this.storeToDate = new Date(fromDate)
      // this.avlblTimeSlots();
      // this.presentLoading();
    }
  }

  setRange(fromdate) {
    let item = new Date(fromdate);
    this.calenderMode = "range";
    this.optionsMulti = {
      pickMode: this.calenderMode,
      // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
      disableWeeks: this.disabelDay,
    }
    //  console.log("from Date=>", item.getFullYear(), item.getMonth() + 1, item.getDate());
    let day1 = item.getFullYear().toString() + "-" + (item.getMonth() + 1).toString() + "-" + item.getDate().toString();
    let day2 = this.storeToDate.getFullYear().toString() + "-" + (this.storeToDate.getMonth() + 1).toString() + "-" + this.storeToDate.getDate().toString();
    this.frombdate = day1;
    this.tobdata = day2;
    // this.showformated_date = new Date(day1).toString().split(' ')[0] + ", " + new Date(day1).toString().split(' ')[1] + " " + new Date(day1).toString().split(' ')[2]
    // console.log(this.showformated_date)
    // console.log(this.tobdata)

    console.log("To date=>", this.storeToDate.getFullYear(), this.storeToDate.getMonth() + 1, this.storeToDate.getDate());
    this.dateRange = {
      from: new Date(item.getFullYear(), item.getMonth() + 1, item.getDate()),
      to: new Date(this.storeToDate.getFullYear(), this.storeToDate.getMonth() + 1, this.storeToDate.getDate())
    };
    console.log(this.dateRange, "check daterange")
    this.storeFromDate = this.dateRange.from;
    this.storeToDate = this.dateRange.to;
    // this.avlblTimeSlots();
    // this.presentLoading();
    item = null;
    console.log("from=>", this.dateRange.from);
    console.log("to=>", this.dateRange.to);

    //     var start = new Date(this.dateRange.from);
    //     var end = new Date(this.dateRange.to);
    //     var loop = new Date(start);
    //     let rangday = []
    //     while(loop <= end){
    //     console.log(loop,"chday");  
    //     let date = new Date(loop);
    //     let changeformat = date.setDate(date.getDate() + 1)
    //     rangday.push(new Date(changeformat).toISOString().split("T")[0])
    //    var newDate = loop.setDate(loop.getDate() + 1);
    //    loop = new Date(newDate);
    // }
    //   this.selecteddates = rangday
    this.getslots();
    //   console.log(this.selectedDate)
  }
  //-------------/\--------SOME SPECIAL FUNCTION'S-----------/\-------------//

  //--------------------><------------------------------------------><--------------------------------------><--------------------

  //---------------\/-------create calender related function------------\/---------//

  getBtwDays(start, end) {
    console.log("disableDates=", this.disabelDay);
    let remDate = [];
    let completedday = [];
    for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt));
      let date1 = new Date(dt);
      let date2 = new Date();
      date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      if (date1 > date2 && !this.disabelDay.includes(date1.getDay())) {
        remDate.push(new Date(dt));
      }
      else if (date1 < date2 && !this.disabelDay.includes(date1.getDay())) {
        completedday.push(new Date(dt))
      }
    }
    console.log("reminigDays=>", remDate);
    this.getBtwDayslist = {
      totalDays: arr.length,
      reminingDays: remDate.length,
      completedday: completedday.length
    }
    console.log(this.getBtwDayslist, "=============================<><><");

    return this.getBtwDayslist;
  }

  getBkgDateCaleForResch(fromDate, toDate) {
    this.storeDates = [];
    console.log("isRecedleDateList=>", this.storeRescheduleDate);
    console.log("isRecedleAltDateList=>", this.storeRescheduleAltDate);
    const FromDate = new Date(fromDate);
    const ToDate = new Date(toDate);
    console.log("FromDate", FromDate);
    console.log("ToDate", ToDate);
    let dateArray = String(fromDate).split(" ");
    this.year = dateArray[3];
    this.month = dateArray[1];
    let prevDate = new Date(FromDate.getFullYear(), FromDate.getMonth(), 0).getDay();
    console.log("prevDate", prevDate);
    if (prevDate < 6) {
      for (let i = prevDate; i >= 0; i--) {
        this.storeDates.push({
          fullDate: " ",
          year: " ",
          month: " ",
          date: " ",
          dayId: " ",
          dateStrg: "",
          day: "",
        });
      }
    }

    let monthEnd = new Date(FromDate.getFullYear(), FromDate.getMonth() + 1, 0).getDate();
    // console.log("monthEnd=>", monthEnd);
    for (let i = 1; i <= monthEnd; i++) {
      if (i == 1) {
        this.displayMonth = new Date(FromDate.getFullYear(), FromDate.getMonth(), i);
        // console.log("displayMonth=>", this.displayMonth);
      }
      this.storeDates.push({
        fullDate: new Date(FromDate.getFullYear(), FromDate.getMonth(), i),
        year: FromDate.getFullYear(),
        month: FromDate.getMonth() + 1,
        date: i,
        dayId: new Date(FromDate.getFullYear(), FromDate.getMonth(), i).getDay(),
        dateStrg: new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString(),
        day: new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString().slice(0, 4)
      });
      console.log("storeDate=>", this.storeDates);
    }
    // this.showcalender=true;
    console.log("storeDate=>", this.storeDates);
  }

  nextMonth() {
    let nextMonth = new Date(this.displayMonth.getFullYear(), this.displayMonth.getMonth() + 1, 1);
    let dateArray = String(nextMonth).split(" ");
    this.year = dateArray[3];
    this.month = dateArray[1];
    console.log("nextMonth", nextMonth);
    console.log(dateArray, "datearray");
    this.getBkgDateCaleForResch(new Date(nextMonth), new Date(this.myToDate));
  }
  prevMonth() {
    let prevMonth = new Date(this.displayMonth.getFullYear(), this.displayMonth.getMonth() - 1, 1);
    let dateArray = String(prevMonth).split(" ");
    this.year = dateArray[3];
    this.month = dateArray[1];
    console.log(dateArray, "datearray");

    this.getBkgDateCaleForResch(new Date(prevMonth), new Date(this.myToDate));
  }

  storeWorkingDayIndex: any;
  clupWorkingHr(data) {
    this.showsledate = null;
    this.change_formated_dates = [];
    if (data != null) {
      console.log(data, "check")
      let days = []
      let day = data.split(",");
      days.push(day);
      let disdays = []
      days[0].forEach(item => {
        disdays.push(Number(item))
      })
      console.log(disdays)
      this.storeWorkingDayIndex = [];
      var daysIndex = [0, 1, 2, 3, 4, 5, 6,];

      this.disabelDay = [];
      if (disdays != null) {
        //console.log("yes Program Days availabel");
        for (let item of disdays) {
          console.log(item, "c1")
          this.storeWorkingDayIndex.push(item - 1);
        }
        let weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        console.log("wrkingIndex=>", this.storeWorkingDayIndex);
        console.log("wrkingIndex=>", this.storeWorkingDayIndex[0]);
        this.startday = weekdays[this.storeWorkingDayIndex[0]];
        this.endday = weekdays[this.storeWorkingDayIndex[this.storeWorkingDayIndex.length - 1]];
        console.log("wrkingIndex=>", this.startday);
        console.log("wrkingIndex=>", this.endday);
        for (let item of daysIndex) {
          if (this.storeWorkingDayIndex.includes(item) == false) {
            this.disabelDay.push(item);
            console.log(this.disabelDay)
          }
        }
      }
      else {
        console.log("not Program Days availabel");
        this.disabelDay = [];
      }
      console.log("disaabel==>", this.disabelDay);
    }
    else {
      this.disabelDay = [];
    }
  }

  //---------------\/-------create calender related function------------\/---------//


  //###################################################################################
  //*****************************************************************************************************************
  //---------010101010101010----------------------------PAGE FLOW'S------------------010101010101001010--------------//
  //*****************************************************************************************************************
  //###################################################################################


  ionViewWillEnter() {
    this.isShow = false
    // this.openactionsheet();
    this.showformated_date = new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]
    console.log(window.localStorage['Physio']);
    this.tymVal = window.localStorage['Physio'];
    let CD = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().split(" ")[0];
    console.log('tym', this.tymVal, '==', 'currdate', CD);
    // if (this.tymVal == 0 || CD >= this.tymVal) {
    //   if (window.localStorage['isAddOpened'] == 0) {
    //     this.addCall.getAdd(2, "Physio");
    //   }
    // }


    this.storePhysiotherapyDocList = [];
    this.remaingDates = null;
    this.compday = null;
    this.pageNo = 1;
    this.backflrepeat = false;
    this.selectedprogram = null
    let gender = localStorage.getItem("Gender");
    if (gender == "male" || gender == "Male") {
      this.Male = true;
      this.genderContent = "Male";
      this.Female = false;
    } else {
      this.Female = true;
      this.genderContent = "Female";
      this.Male = false;
    }
    this.Date = new Date();
    let getDate = new Date();
    this.searchDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    // console.log("searchDate=>", this.searchDate);
    this.showListCatPage()
    this.packagetype = 2;
    this.scenter = 'homeList';
    //this.showListPhysiotherapy();
    this.ratingSorting = false;
    this.ratingBasedSortingOrder = "ASC";
    this.showcal = false;
  }

  ionViewWillLeave() {


    if (this.getphysiolist) {
      this.getphysiolist.unsubscribe();
    }
    this.showcal = false;
  }

  showListCatPage() {
    this.presentView = "listCategory"
    // console.log(this.SearchCat);
    let data = JSON.stringify({
      "filter": this.SearchCat
    })
    this.services.postRequest("getPhysioSpeciality", data).subscribe(res => {
      console.log(res);
      this.EmptyData = res.status;
      this.SpecialityList = res.data;
      this.backValue = "goHome";

      //console.log(this.SpecialityList);
      // this.storeRefreshEvent.target.complete();
    });
  }



  showListPhysiotherapy(splId, splname) {

    if (this.getphysiolist) {
      this.getphysiolist.unsubscribe();
    }

    this.backflrepeat = false;
    //this.showphysiotherapyPro(1, 2);
    //this.getPrtclrPhysioDocDetails();
    //this.presentView = "physioProfileInfo";
    this.specialityName = splname;
    this.specialityId = splId;
    this.nextCount = 0;
    this.presentView = "listPhysiotherapy";
    this.backValue = "listCategory1";
    this.headerValue = null;//"PhysioTheraby";
    console.log("searchDate=>", this.searchDate);
    this.curntDate = new Date().toISOString().split("T")[0];
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "doctorGenderChecking": this.genderStatus,
      "doctorGender": this.genderContent,
      //"currentDate": this.curntDate,
      "searchDate": '',//this.searchDate,
      //"day": true,//this.sunMode,
      //"night": false,// this.darkMode,
      "lat": "10.8965729",
      "long": "76.9556144",

      // "lat": "29.62107798734671",
      // "long": "47.587719496877924",
      //"costBasedSorting": false,//this.costSortingStatus,
      //"costBasedSortingOrder": "ASC",//this.costSortingContent,
      "speciality": true,
      "specialityId": this.specialityId,//this.specialityId,
      //"advanceFilter": this.advanceFilterStatus,
      //"advanceFilterCost": this.advanceFilterCost,
      //"advanceFilterOffers": this.advanceFilterOffers,
      //"advanceFilterDistance": this.advanceFilterDistance,
      "limit": 10,
      "pageno": this.pageNo,
      "typeSearch": this.searchStatus,
      "typeSearchContent": this.SearchContent,
      //"current_time": new Date().toTimeString().split(" ")[0],
      "packageType": this.packagetype,
      "reviewBasedSorting": this.ratingSorting,
      "reviewBasedSortingOrder": this.ratingBasedSortingOrder,
      "distanceBasedSorting": this.distanceBasedSorting,
      "distanceBasedSortingOrder": this.distanceBasecSortingOrder,

    });
    this.getphysiolist = this.services.postRequest("patientPhysioSearch", apiData).subscribe(res => {
      console.log(res);

      const interval = setInterval(() => {
        console.log("Trigger from API");
        console.log("No Video");
        this.currentPlaying = null;
        if (this.vdoPlayer) {
          console.log("Video", this.vdoPlayer);
          this.didScrollEvent(event);
          clearInterval(interval);
        }
      }, 1000);


      if (res.status != 0) {
        this.nextCount = res.data[0].nextCount;
        console.log("nextCount", this.nextCount);
      }
      if (this.pageNo != 1) {
        this.EmptyData = res.status;
        console.log("EmtyData=", this.EmptyData);
        for (let item of res.data[0].details) {
          item['mediaDetails'] = item.mediaDetails[0]
          item['Distance'] = Number.parseFloat(item.Distance).toFixed();
          // for (let item2 of item.mediaDetails) {
          let convert = JSON.stringify(this.videoOptions);
          this.videoOptions = JSON.parse(convert);
          item.mediaDetails['playVideOpt'] = this.videoOptions;

          // }
          this.storePhysiotherapyDocList.push(item);
        }


        console.log("added Lst", this.storePhysiotherapyDocList);

        console.log("Page No:", this.pageNo);
      }

      else {
        this.storePhysiotherapyDocList = [];
        // this.EmptyData = res.status;
        // console.log("EmtyData=", this.EmptyData);
        this.EmptyData = res.status;
        console.log("EmtyData=", this.EmptyData);
        for (let item of res.data[0].details) {
          item['mediaDetails'] = item.mediaDetails[0]
          item['Distance'] = Number.parseFloat(item.Distance).toFixed();
          // for (let item2 of item.mediaDetails) {
          let convert = JSON.stringify(this.videoOptions);
          this.videoOptions = JSON.parse(convert);
          item.mediaDetails['playVideOpt'] = this.videoOptions;
          // }
          this.storePhysiotherapyDocList.push(item);
        }



        // console.log("added Lst", this.storePhysiotherapyDocList);
        // console.log("Page No:", this.pageNo);
        // console.log(JSON.parse(this.storePhysiotherapyDocList[0].clinic_list))
        // console.log(JSON.parse(this.storePhysiotherapyDocList[0].location_list))

        // for (let item of res.data[0].details) {
        //   if (item.mediaDetails != null) {
        //     for (let item2 of item.mediaDetails) {
        //       var just = item2['playVideOpt'] = this.videoOptions;
        //     }
        //   }
        //   this.DoctorsList.push(item);
        // }

        var convert = JSON.stringify(this.storePhysiotherapyDocList);
        this.storePhysiotherapyDocList = JSON.parse(convert);
        console.log("first Enter", this.storePhysiotherapyDocList);
        console.log("Page No:", this.pageNo);
      }
      console.log("added Lst", this.storePhysiotherapyDocList);
    });
    this.searchStatus = false;
    this.advanceFilterStatus = false;
    // console.log("added Lst", this.storePhysiotherapyDocList);

  }


  selectcenter(value) {
    console.log(value)
    this.storePhysiotherapyDocList = [];
    this.scenter = value
    if (value == 'homeList') {
      this.packagetype = 2
      this.showListPhysiotherapy(this.specialityId, this.specialityName);
    }
    if (value == 'onlineList') {
      this.packagetype = 1
      this.showListPhysiotherapy(this.specialityId, this.specialityName);
    }
    if (value == 'centerList') {
      this.packagetype = 3
      this.showListPhysiotherapy(this.specialityId, this.specialityName);
    }
  }
  clinic_Name: any;
  clinic_Address: any;
  Location_program: any;
  Clinic_name: any;
  showphysiotherapyPro(data, flow, i, id) {
    this.isShow = false;
    this.clinic_Name = data.clinic_program;
    // this.clinic_Address = data.clinic_location;
    this.Location_program = data.location_program;
    this.Clinic_name = data.ClinicName;
    // if (this.clinic_Address != null) {
    //   this.F_address = this.clinic_Address
    // }
    // if (this.Location_program != null) {
    //   this.F_address = this.Location_program
    // }
    // else {
    //   this.F_address = "";
    // }
    this.clinic_id = data.clinic_id;
    this.location_id = data.location_id;
    this.dealserviceid = id
    this.Docproindex = i;
    this.showbook = false;
    this.selectedprogram = null;
    this.programname = null;
    this.backflrepeat = false;
    console.log(data.doctorId, flow, "checkdataz");
    this.getMedia(data.doctorId);
    this.doctorid = data.doctorId;
    this.presentView = "physioProfileInfo";
    this.backValue = "goPhysioListPage";
    this.showOfferCardPage = true;
    this.showCalenderPage = false;

    this.storeDocterId = 46,//data.doctorId;
      this.storeClinicId = 3,//data.clinicId;

      //this.storeDocName = "farah",//data.vendor_name;
      this.storeDocProImg = //data.doctorProfileImage;
      this.storeDocGender = "male",//data.vendor_contact_gender;
      this.storeDocAge = 34;
    //this.storeDocAdd = //data.clinicLocation;
    // this.storeDocExp = 5;
    // this.storeDocNofRating = 4.5;
    this.storeDocNofReviews = 160;
    this.storeDocLikePercent = 100;
    // this.headerValue = this.particularPhysioDocDetails.vendor_name,//this.storeDocName;

    this.getPrtclrPhysioDocDetails();
    this.getDocServiceList();
  }

  getPrtclrPhysioDocDetails() {

    if (this.clinic_id == null) {
      this.clinic_id = "";
    }
    if (this.location_id == null) {
      this.location_id = "";
    }


    this.particularPhysioDocDetails = null;
    let apiData = JSON.stringify({
      // "doctorId": this.storeDocterId,
      // "clinicId": this.storeClinicId,
      "doctorId": this.doctorid,
      //"clinicId": 3,
      "lat": "29.62107798734671",
      "long": "47.587719496877924",
      //"currentDate": new Date().toISOString().split("T")[0],
      "patientId": localStorage.getItem("patient_id"),
      "searchDate": this.searchDate,
      "specialityId": this.specialityId,
      "packageType": this.packagetype,
      "clinic_id": this.clinic_id,
      "location_id": this.location_id,
      //"current_time": new Date().toTimeString().split(" ")[0],

    });
    console.log("sent perclr Doc Details=>", JSON.parse(apiData));
    this.services.postRequest("particularPhysioDetails", apiData).subscribe(res => {
      console.log(res);
      this.EmptyData = res.status;
      this.particularPhysioDocDetails = res.data[0];
      console.log(this.particularPhysioDocDetails, "check");

      this.revArr = JSON.parse(this.particularPhysioDocDetails.review_comment);
      console.log("prtclrDocDet", this.revArr);

      // this.getReviewCommands = JSON.parse(this.particularDocterPro.review_comment);
      console.log("particular Doc Details=>", this.particularPhysioDocDetails);
      this.clinic_Address = this.particularPhysioDocDetails.clinic_location;
      this.storeDocProImg = this.particularPhysioDocDetails.doctorProfileImage;
      this.storeDocName = this.particularPhysioDocDetails.vendor_name;
      this.headerValue = this.particularPhysioDocDetails.vendor_name;
      this.storeDocAdd = this.particularPhysioDocDetails.docotrAddress;
      this.storeDocExp = this.particularPhysioDocDetails.experience;
      this.storeDocNofRating = this.particularPhysioDocDetails.review.toFixed(1);
      this.Distance = this.particularPhysioDocDetails.Distance.toFixed();
      this.reviewpercenage = this.particularPhysioDocDetails.review_percentage.toFixed();
      this.Like = this.particularPhysioDocDetails.likes_count;
      this.likestatus = this.particularPhysioDocDetails.isLiked;
      this.Docselfdec = this.particularPhysioDocDetails.vendor_selfDes;

      // if (this.clinic_Address != null) {
      //   this.F_address = this.clinic_Address.split(',')[0]
      // }

      console.log(this.likestatus)

      this.program = this.particularPhysioDocDetails.manage_package
      //console.log(this.program[0].slot,"physio_program")
      let program = this.program;
      console.log(program, "check slots", this.temp_pack_id)

      if (this.presentView == 'physioProfileRepeatInfo') {
        var result = program.find(obj => {
          return obj.package_id === this.temp_pack_id;
        })
        this.backflrepeat = true;
        console.log(result, "check it the repwat  flow")
        this.selectedprogram = result;
        this.programname = result.package_name;
        this.packageid = result.package_id;
        this.timeslots = result.slot;
        console.log(this.timeslots);

        this.working_days = result.working_days
        this.clupWorkingHr(this.working_days);
        this.dealoption = result.deal_options;
        this.dealvalue = result.deal_amount;
        this.totalAmount = result.fee;
        this.package_details = result.package_details
        this.sessions = result.session;
        this.package_amount = result.fee;



        if (this.dealoption == "Amount") {
          this.dealType = "KWD";
          this.finalPay = Number(this.totalAmount) - Number(this.dealvalue);
        } else if (this.dealoption == "Percentage") {
          this.dealType = "%";
          this.finalPay = Number(this.totalAmount) - (Number(this.totalAmount) * Number(this.dealvalue)) / 100;
        } else {
          this.finalPay = this.totalAmount;
        }


        this.calenderMode = "single";
        this.optionsMulti = {
          pickMode: this.calenderMode,
          // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
          disableWeeks: this.disabelDay,
        };

      }
      console.log(this.revArr, "check")
      console.log(this.timeslots)



      //console.log(this.dealserviceid,"------------------------->")
      let packagedetails = this.particularPhysioDocDetails.manage_package
      //console.log(packagedetails,'============================>');

      if (this.dealserviceid != undefined) {
        setTimeout(() => {
          this.scroll();
        }, 500);
        let obj = packagedetails.find(deal => deal.deal_service_type_id === this.dealserviceid);
        this.selectedprogram = obj
        console.log(obj);
        this.programname = this.selectedprogram.package_name;
        this.packageid = this.selectedprogram.package_id;
        this.timeslots = this.selectedprogram.slot;
        console.log(this.timeslots);

        this.working_days = this.selectedprogram.working_days
        this.clupWorkingHr(this.working_days);
        this.dealoption = this.selectedprogram.deal_options;
        this.dealvalue = this.selectedprogram.deal_amount;
        this.totalAmount = this.selectedprogram.fee;
        this.sessions = this.selectedprogram.session
        this.package_amount = this.selectedprogram.fee
        this.package_details = this.selectedprogram.package_details

        if (this.dealoption == "Amount") {
          this.dealType = "KWD";
          this.finalPay = Number(this.totalAmount) - Number(this.dealvalue);
        } else if (this.dealoption == "Percentage") {
          this.dealType = "%";
          this.finalPay = Number(this.totalAmount) - (Number(this.totalAmount) * Number(this.dealvalue)) / 100;
        } else {
          this.finalPay = this.totalAmount;
        }

        this.calenderMode = "single";
        this.optionsMulti = {
          pickMode: this.calenderMode,
          // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
          disableWeeks: this.disabelDay,
        };
      }
      //this.select_program();

    });


    //console.log(this.particularPhysioDocDetails.manage_package)







  }

  getMedia(tr_id) {

    let tempArr = [];
    if (this.mediaReq) {
      this.mediaReq.unsubscribe();
    }
    this.profileMediaDetails = [];
    let apiData2 = JSON.stringify({
      "doctorId": tr_id,
      "limit": 1000,
      "pageno": 1
    });
    this.mediaReq = this.services.postRequest("getMediaDetailsByDoctor", apiData2).subscribe(res => {
      console.log("mediaDetails=>", res);
      for (let item of res.data[0].details) {
        tempArr.push(item);
        if (tempArr.length == 3) {
          this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
          console.log(this.profileMediaDetails, "chcek media")
          tempArr = [];
        }
      }
      if (tempArr.length > 0) {
        this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
      }
    });
  }
  reqslots: any;

  async getslots() {
    const loading = await this.loadingController.create({
      message: "Please Wait....."
    });
    await loading.present();


    let apidata = JSON.stringify({
      "doctorId": this.doctorid,
      "slot_time": this.frmtime,
      "selected_days": this.selecteddates,
      "packageId": this.packageid,
    })
    this.reqslots = this.services.postRequest("getPhysioSlotStatus", apidata).subscribe(async res => {
      console.log(res, "check slots")
      await loading.dismiss();
      let obnj = res.data;
      let storeAvlDate = []

      obnj.slotStatus.forEach(a => {
        if (a.bookedStatus == 'false') {
          storeAvlDate.push(a.date)
        }
        //storeAvlDate.push(res.data.nextAvailableSlots)  
      })
      obnj.nextAvailableSlots.forEach(b => {
        storeAvlDate.push(b)
      })
      console.log(storeAvlDate);
      let ordersletdates = storeAvlDate.sort((a, b) => Date.parse(a) - Date.parse(b))
      this.frombdate = ordersletdates[0];

      this.tobdata = ordersletdates[ordersletdates.length - 1]

      console.log(this.selecteddates[0], "===============", this.tobdata);








      this.selecteddates = storeAvlDate;

      let changeformat = [];


      this.selecteddates.forEach(data => {
        changeformat.push(this.getFormattedDateTime(data, 'Date1'))
        console.log(changeformat);
      })



      let assend_dates = changeformat.sort((a, b) => Date.parse(a) - Date.parse(b))

      //  console.log(this.frombdate, "=========", this.tobdata);



      this.showsledate = assend_dates.slice(0, 3);
      this.change_formated_dates = assend_dates;
      this.showformated_date = new Date(this.showsledate[0]).toString().slice(0, 3) + ', ' + new Date(this.showsledate[0]).toString().slice(4, 10);

      getMonthDifference(new Date(this.showsledate[0]), new Date(this.tobdata));


      function getMonthDifference(startDate, endDate) {

        let monthdiff = endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear())

        for (let i = 1; i <= monthdiff; i++) {
          console.log('check difference', i);
          setTimeout(() => {
            $(".forward").trigger("click");
          }, 1000);
        }
      }


      this.dateRange = this.selecteddates;
      this.calenderMode = 'multi';
      this.disabelDay = []
      this.optionsMulti = {
        pickMode: this.calenderMode,
        // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
        disableWeeks: this.disabelDay,
      };
    })
  }

  getDocServiceList() {
    let apiData = JSON.stringify({
      "doctorId": Number(this.storeDocterId),
    });
    this.services.postRequest("doctorServiceDropDown", apiData).subscribe(res => {
      console.log(res);
      this.storeDocServiceList = res.data?.details;
      this.selectedService = String(this.storeDocServiceList[0]?.serviceTypeId);
      /*this.doctorServiceFees = this.storeDocServiceList[0].total;
      console.log("doctServFees=>", this.doctorServiceFees);
      this.serviceDuration = {
        hr: Math.floor(this.storeDocServiceList[0].duration / 60),
        min: this.storeDocServiceList[0].duration % 60
      }*/
      console.log("DropDown=>", this.storeDocServiceList);
      console.log(this.selectedService);
    })
  }

  // showHide() {
  //   this.isShow = !this.isShow;
  // }

  showHide() {
    if (this.isShow == false) {
      this.isShow = true
    }
    else if (this.isShow == true) {
      this.isShow = false
    }
  }

  showSelectDatePage(data) {
    this.presentView = "physioProfileInfo";
    this.headerValue = "Shoulder Pain";
    this.backValue = "goPhysioProCardPage";
    this.showOfferCardPage = false;
    this.showCalenderPage = true;
    this.dateRange = null;
    this.storeFromDate = null;
    this.storeToDate = null;
    // this.SlotId = null;
    // this.storeTimeSlots = null;
    // this.storeSelectedSlot = null;

  }

  showBkgConfirPage() {
    console.log(this.showsledate, this.dateRange);

    if (this.showsledate && this.dateRange) {
      this.storeFromDate = this.selecteddates[0];
      this.storeToDate = this.selecteddates[this.selecteddates.length - 1];
      console.log(this.selecteddates[0], 'and', this.selecteddates[this.selecteddates.length - 1])
      console.log('under implementation',
        new Date(this.storeFromDate).toISOString().split("T")[0])
      // this.frombdate = new Date(this.storeFromDate ).toISOString().split("T")[0];
      // this.tobdata = new Date(this.storeToDate ).toISOString().split("T")[0];
      console.log(this.frombdate, "==", this.tobdata)

      this.presentView = 'bookingConfirmPage';
      // this.headerValue = "Booking Confirmation";
      this.headerValue = this.addCall.title40;



      this.backValue = "goPhysioProCardPage";
      this.getPatientBasicDetails();
    }
  }
  F_address: any;
  getPatientBasicDetails() {
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "currentTime": new Date().toTimeString().split(" ")[0]
    });
    console.log("send patient Basic Details Reqst=>", JSON.parse(apiData));
    this.services.postRequest("getPatientProfile", apiData).subscribe(res => {
      console.log(res);
      if (res.msg == "Success") {
        this.patientBasicDetails = res.data[0];
        if (this.packagetype == '2') {
          this.F_address = this.patientBasicDetails.address;
        } else if (this.packagetype == '1') {
          this.F_address = this.clinic_Address?.split(',')[0];
        }
        else {
          this.F_address = '';
        }

        this.patientmemberDetails = this.patientBasicDetails.patientmemberDetails;
        this.slctdMemVal = this.patientBasicDetails.patientId;
        this.BkgConPatientName = this.patientBasicDetails.name;
        this.currentMemberId = localStorage.getItem("patient_id");
        this.Email = this.patientBasicDetails.email;
        this.Phoneno - this.patientBasicDetails.phone_no;
        console.log("Patient Basic Details=>", this.patientBasicDetails);
      }
    });
  }
  selectMember(value, membId) {
    this.slctdMemVal = membId;
    this.BkgConPatientName = value;
    this.currentMemberId = membId;
    console.log("name:", value, "memberId:", membId);
  }



  //--------------

  showBookingListPage() {
    this.presentView = "bookingListPage";
    this.backValue = "listCategory1";
    // this.headerValue = "Booking";
    this.headerValue = this.addCall.title143;
    this.pageNo = 1;
    this.EmptyData = null;
    this.storeDocBookingList = [];
    this.showAppointmentListPage();
  }
  checkcurdate: any;
  showAppointmentListPage() {
    this.checkcurdate = new Date().toISOString();
    this.nextCount = 0;
    // this.apMntAddFltrPopUp = false;
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      // "current_time": new Date().toTimeString().split(" ")[0],
      "pageno": this.pageNo,
      "limit": 10
    });
    console.log("send Booking list Reqst=>", JSON.parse(apiData));
    this.services.postRequest("patientPhysioBookedAppointmentList", apiData).subscribe(res => {
      console.log(res);
      this.backflrepeat = true;
      if (res.status != 0) {
        this.nextCount = res.data[0].nextCount;
        console.log("nextCount", this.nextCount);
      }
      if (this.pageNo != 1) {
        for (let item of res.data[0].details) {
          // item.clinicDetails = JSON.parse(item.clinicDetails);
          this.storeDocBookingList.push(item);


        }
        console.log("added LIst", this.storeDocBookingList);
        console.log("Page No:", this.pageNo);
      }
      else {
        this.EmptyData = res.status;
        if (res.status == 1) {
          this.storeDocBookingList = [];
          for (let item of res.data[0].details) {
            //item.clinicDetails = JSON.parse(item.clinicDetails);
            this.storeDocBookingList.push(item);
            //console.log("check item========", typeof (item.from_date));
          }
        }
        //  console.log("first Enter", this.storeDocBookingList);

        // console.log("Page No:", this.pageNo);
      }
    });
  }

  viewBookingDetail(item, curpage) {
    let changeformat = [];
    this.showsledate = null;
    this.change_formated_dates = [];
    console.log(curpage, "====================");

    item.selected_dates?.split(',').forEach(data => {
      changeformat.push(this.getFormattedDateTime(data, 'Date1'))
    })
    console.log(changeformat);
    let assend_dates = changeformat.sort((a, b) => Date.parse(a) - Date.parse(b));

    this.showsledate = assend_dates.slice(0, 3);
    this.change_formated_dates = assend_dates;


    if (curpage == "historyviewBookingInfoPage") {
      this.backValue = "bookingHisListPage";
      this.presentView = "historyviewBookingInfoPage";
      // this.headerValue = "View Booking History ";
      this.headerValue = this.addCall.title135;
      this.particularBkgDetails = item;
      console.log(this.particularBkgDetails);
      console.log(this.backValue);
    }
    else if (curpage == "bookingListPage") {

      this.presentView = "viewBookingInfoPage";
      this.backValue = "goBookingListPage";
      // this.headerValue = "View Booking";
      this.headerValue = this.addCall.title133;
      this.particularBkgDetails = item;
      console.log(item.selected_dates);
      console.log(this.particularBkgDetails);
      console.log(this.backValue);
      this.showslt_dates = [];
    }
  }
  intersection: any;
  compltedays: any = [];
  showsheduledate: any;

  showMySchadule() {
    this.presentView = "viewMyShcedulePage";
    this.backValue = "goViewBookingPage";
    this.headerValue = "My Schedule";
    // this.headerValue = this.particularBkgDetails.tr_package_name + "-My Schedule";
    // this.clupWorkingHr(this.particularBkgDetails.pacckageDays);
    console.log(this.storeDocBookingList.from_date, "==", this.storeDocBookingList.to_date)
    let fromDate = this.particularBkgDetails.from_date.split("T")[0];//this.particularBkgDetails.from_date.split("T")[0];
    let toDate = this.particularBkgDetails.to_date.split("T")[0]; //this.particularBkgDetails.to_date.split("T")[0];
    console.log(this.particularBkgDetails.from_date);
    let showdate = this.particularBkgDetails.from_date

    this.showsheduledate = new Date(showdate).toString().split(' ')[0] + ", " + new Date(showdate).toString().split(' ')[1] + " " + new Date(showdate).toString().split(' ')[2]

    console.log(this.particularBkgDetails.specificDateResheduleList)
    console.log(this.particularBkgDetails.selected_dates)
    let selecteddates = this.particularBkgDetails.selected_dates.split(",");

    selecteddates.forEach(item => {
      //console.log(item)
      this.showslt_dates.push(new Date(item).toString().substring(0, 15))
      if (new Date(item) < new Date()) {
        this.compltedays.push(new Date(item).toString().substring(0, 15))
      }
      this.intersection = this.showslt_dates.filter(x => !this.compltedays.includes(x));


    })




    if (this.particularBkgDetails.specificDateResheduleList == null) {
      this.showreschedulrdate = "null",
        this.tobeshowreschedulrdate = "null"
    }
    else {
      let reschdule = JSON.parse(this.particularBkgDetails.specificDateResheduleList);
      this.showreschedulrdate = new Date(reschdule[0].rescheduled_date).toString().substring(0, 15);
      console.log(this.showreschedulrdate)
      this.tobeshowreschedulrdate = new Date(reschdule[0].to_be_reschedule).toString().substring(0, 15);
      console.log(this.tobeshowreschedulrdate)
    }

    this.myFromDate = new Date(this.particularBkgDetails.from_date);//new Date(fromDate.split("-")[0], (fromDate.split("-")[1] - 1), fromDate.split("-")[2]);
    this.myToDate = new Date(this.particularBkgDetails.to_date);//new Date(toDate.split("-")[0], (toDate.split("-")[1] - 1), toDate.split("-")[2]);
    console.log("myFromDate", this.myFromDate);
    console.log("myToDate", this.myToDate);
    this.chkCrnDate = new Date(new Date().setHours(0, 0, 0, 0));
    // this.chkCrnDate = new Date("09/16/2021"); ;
    console.log(this.chkCrnDate);
    this.crnDate = new Date().getDate();
    this.crnYear = new Date().getFullYear();
    this.crnMonth = new Date().getMonth() + 1;
    this.getBkgDateCaleForResch(new Date(fromDate), new Date(toDate));
    let dates = this.getBtwDays(new Date(fromDate), new Date(toDate));
    console.log(dates.reminingDays);
    console.log(this.particularBkgDetails.sessions);



    // if (dates.reminingDays < 10) {
    //   this.remaingDates = '0' + dates.reminingDays;
    // }
    // else {
    //   this.remaingDates = dates.reminingDays;
    // }
    // this.option.percent = (dates.reminingDays / this.particularBkgDetails.sessions) * 100;
    // console.log("remainig Days=>", this.remaingDates);


    console.log(this.particularBkgDetails.sessions)
    console.log(this.showslt_dates)
    console.log(this.showslt_dates[0])
    console.log(this.showslt_dates[this.showslt_dates.length - 1])

    let assend_dates = this.showslt_dates.sort((a, b) => Date.parse(a) - Date.parse(b))
    console.log(assend_dates)

    let datenow = new Date()

    let count = 0

    console.log(datenow)
    for (let i = 0; i < assend_dates.length; i++) {
      if (datenow >= new Date(assend_dates[i])) {
        count++;
        console.log(assend_dates[i]);

      } else {
        console.log("break", assend_dates[i]);
        break;
      }
    }
    console.log(this.getBtwDayslist.reminingDays, "=================================><><><><><><");

    this.remaingDates = this.getBtwDayslist.reminingDays;//assend_dates.length - count;
    this.option.percent = (this.getBtwDayslist.reminingDays / this.particularBkgDetails.sessions) * 100;
    console.log(assend_dates.length - count);


    this.compday = this.getBtwDayslist.completedday
    this.option1.percent = (this.getBtwDayslist.completedday / this.particularBkgDetails.sessions) * 100;
    this.option1.clockwise = false




  }

  async callCancelBkgApi() {
    const loading = await this.loadingController.create({
      message: "Loading....."
    });
    await loading.present();
    console.log(this.storeBookingId);
    let apiData = JSON.stringify({
      "bookingId": this.storeBookingId,
      "patientId": localStorage.getItem("patient_id")
      // "cancel_time": new Date().toLocaleTimeString()
    });
    console.log("send refund Reqst=>", JSON.parse(apiData));
    this.services.postRequest("cancelPhysioAppointment", apiData).subscribe(async res => {
      console.log(res);
      if (res.ststus != 0) {
        await loading.dismiss();
        this.pageNo = 1;
        this.loadingController.dismiss();

        if (res.data[0].msgcode == 1) {
          // this.AlertInfo("Your booking canceled successfully, Amount will be refunded within 7 working days", res.status);
          this.AlertInfo(this.addCall.title449, res.status);
        } else if (res.data[0].msgcode == 2) {
          // this.AlertInfo("you reached your cancelation limit ,Your booking canceled successfully, Amount will be refunded within 7 working days", res.status);
          this.AlertInfo(this.addCall.title450, res.status);
        } else if (res.data[0].msgcode == 3) {
          // this.AlertInfo("you reached your cancelation limit ,so unable to cancel your booking", 0);
          this.AlertInfo(this.addCall.title451, 0);
        }

        this.showBookingListPage();
        // this.AlertInfo("Your booking canceled successfully, Amount will be refunded within 7 working days", res.status);
      }
      else {
        // this.toastMessage = "Booking Cancel Failed";
        // this.presentToast();
        this.loadingController.dismiss();
        this.AlertInfo(res.msg, res.status);
        this.showBookingListPage();
      }
    });
  }
  showslt_dayes: any = [];
  reSchedulePage(item) {
    console.log(item)
    this.storedetails = item
    this.storeRescheduleDate = { fullDate: null, formatedDate: null };
    this.storeRescheduleAltDate = { fullDate: null, formatedDate: null };
    this.presentView = "changeMyShcedulePage";
    this.backValue = "goBookingListPage";
    this.ReSchBtnValue = "Reschedule";//"Select Reschedule Day";
    this.storeTimeSlots = null;
    this.storeSelectedSlot = null;
    this.particularBkgDetails = item;


    if (this.particularBkgDetails.specificDateResheduleList == null) {
      this.showreschedulrdate = "null",
        this.tobeshowreschedulrdate = "null"
    }
    else {
      let reschdule = JSON.parse(this.particularBkgDetails.specificDateResheduleList);
      this.showreschedulrdate = new Date(reschdule[0].rescheduled_date).toString().substring(0, 15);
      console.log(this.showreschedulrdate)
      this.tobeshowreschedulrdate = new Date(reschdule[0].to_be_reschedule).toString().substring(0, 15);
      console.log(this.tobeshowreschedulrdate)
    }
    // this.headerValue = this.particularBkgDetails.tr_package_name + "-My Schedule";

    // this.clupWorkingHr(this.particularBkgDetails.pacckageDays);
    let selecteddates = this.particularBkgDetails.selected_dates.split(",");
    // selecteddates.forEach(item => {
    //   //console.log(item)
    //   this.showslt_dates.push(new Date(item).toString().substring(0,15))
    //   this.showslt_dayes.push(new Date(item).toString().substring(0,4))
    // })




    selecteddates.forEach(item => {

      //this.showslt_dates.push(new Date(item).toString().substring(0,15))
      this.showslt_dayes.push(new Date(item).toString().substring(0, 4))
      this.showslt_dates.push(new Date(item).toString().substring(0, 15))
      if (new Date(item) < new Date()) {
        this.compltedays.push(new Date(item).toString().substring(0, 15))
      }
      this.intersection = this.showslt_dates.filter(x => !this.compltedays.includes(x));
    })
    console.log(this.showslt_dates)
    console.log(this.showslt_dayes)

    let fromDate = this.particularBkgDetails.from_date.split("T")[0];//this.particularBkgDetails.from_date.split("T")[0];
    let toDate = this.particularBkgDetails.to_date.split("T")[0]; //this.particularBkgDetails.to_date.split("T")[0];
    let showdate = this.particularBkgDetails.from_date
    this.showsheduledate = new Date(showdate).toString().split(' ')[0] + ", " + new Date(showdate).toString().split(' ')[1] + " " + new Date(showdate).toString().split(' ')[2]
    console.log("myFromDate", fromDate);
    console.log("myToDate", toDate);

    this.myFromDate = new Date(this.particularBkgDetails.from_date);//new Date(fromDate.split("-")[0], (fromDate.split("-")[1] - 1), fromDate.split("-")[2]);
    this.myToDate = new Date(this.particularBkgDetails.to_date);//new Date(toDate.split("-")[0], (toDate.split("-")[1] - 1), toDate.split("-")[2]);
    console.log("myFromDate", this.myFromDate);
    console.log("myToDate", this.myToDate);
    this.chkCrnDate = new Date(new Date().setHours(0, 0, 0, 0));
    // this.chkCrnDate = new Date("09/16/2021"); ;
    console.log(this.chkCrnDate);
    this.crnDate = new Date().getDate();
    this.crnYear = new Date().getFullYear();
    this.crnMonth = new Date().getMonth() + 1;
    this.getBkgDateCaleForResch(new Date(fromDate), new Date(toDate));
  }

  rescheduleIt(data) {
    console.log(data)
    let d = new Date(data.dateStrg);
    let frmtedDate = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
    console.log("frmated Date=>", frmtedDate);
    console.log("frmated Date=>", data);
    // if ((data.fullDate <= this.myToDate) &&
    //   (data.fullDate > this.chkCrnDate) &&
    //   data.fullDate >= this.myFromDate) {
    //   this.storeRescheduleDate = {
    //     fullDate: data.dateStrg,
    //     formatedDate: frmtedDate
    //   }
    //   console.log("isRecedleDateList=>", this.storeRescheduleDate);
    // }
    if ((this.intersection.includes(data.dateStrg)) && (data.fullDate <= this.myToDate)) {
      this.storeRescheduleDate = {
        fullDate: data.dateStrg,
        formatedDate: frmtedDate
      }

      console.log("isRecedleDateList=>", this.storeRescheduleDate);
    }
    console.log(this.showslt_dayes);

    if ((data.fullDate > this.myToDate) && (this.showslt_dayes.includes(data.day))) {
      this.storeRescheduleAltDate = {
        fullDate: data.dateStrg,
        formatedDate: frmtedDate
      };
      // this.storedetails =
      this.doctorid = this.storedetails.doctor_id;
      this.frmtime = this.storedetails.from_time;
      this.selecteddates = this.storeRescheduleAltDate.formatedDate;
      this.packageid = this.storedetails.package_id;
      //this.getslots();
      console.log("isRecedleAltDateList=>", this.storeRescheduleAltDate);
    }
  }

  showBookingHisListPage() {

    this.presentView = "bookingHisListPage";
    // this.headerValue = "Booking History";
    this.headerValue = this.addCall.title134;
    this.backValue = "goBookingListPage";
    this.pageNo = 1;
    this.historyList = [];
    this.nextCount = 0;
    if (this.pageNo == 1) {
      this.EmptyData = null;
    }

    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "limit": 10,
      "pageno": this.pageNo
    });
    console.log("send booking His List Reqst=>", JSON.parse(apiData));
    this.services.postRequest("physioBookedAppointmentHistoryList", apiData).subscribe(res => {
      console.log(res);

      if (this.pageNo == 1) {
        this.EmptyData = res.status;
        console.log(res.status);
      }

      if (res.status == 1) {
        this.nextCount = res.data[0].nextCount;
        this.EmptyData = 1;
        if (this.pageNo != 1) {
          for (let item of res.data[0].details) {
            this.historyList.push(item);
          }
          console.log("added LIst", this.historyList);
          console.log("Page No:", this.pageNo);
        }
        else {
          this.historyList = res.data[0].details;
          console.log("first Enter", this.historyList);
          console.log("Page No:", this.pageNo);
        }
      }
      //this.historyList = res.data[0].details;
    });
  }

  showReviewPopUp(docId, docImg, docName) {
    console.log("revDocDetails=>", docId, docImg, docName);
    this.getReviewPopUp = !this.getReviewPopUp;
    if (this.getReviewPopUp == true) {
      this.storeDocProImg = docImg;
      this.storeDocName = docName;
      this.doctorid = docId;
    }
  }

  async reviewPopup(Id: any, Img: any, Name: any, reviewcount, physio_bookingid) {
    console.log('reviewcount,', reviewcount);


    const alert = await this.modalCtrl.create({
      component: ReviewPage,
      cssClass: 'review-class',
      componentProps: {
        Id: Id,
        Img: Img,
        Name: Name,
        From: "Physiotheraphy",
        bookingId: physio_bookingid,
      }
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
      if (data.data == 'dismiss') {
        this.showBookingHisListPage();
      }

    })
    await alert.present();
  }

  // getReview() {
  //   console.log("str Rating=>", this.getStrRating);
  //   let apiData = JSON.stringify({
  //     "doctorId": this.setRevDocId,
  //     "patientId": localStorage.getItem("patient_id"),
  //     "value": this.getStrRating,
  //     "remarks": this.getRemark
  //   });
  //   console.log("send Review=>", JSON.parse(apiData));
  //   this.services.postRequest("updateDoctorReview", apiData).subscribe(res => {
  //     console.log(res);
  //     if (res.status == 1) {
  //       this.presentToast(res.msg);
  //       this.getReviewPopUp = false;
  //       this.getRemark = null;
  //     };
  //   });
  // }
  showcal: boolean = false;
  chooseSlot(i) {

    this.showbook = false;
    this.showcal = true;
    this.slotindex = null;
    this.slotindex = i
    console.log(this.timeslots[this.slotindex], "checkslotstime")
    this.frmtime = this.timeslots[this.slotindex].from_time;
    this.totime = this.timeslots[this.slotindex].to_time;
    setTimeout(() => {
      this.scroll();
    }, 500);
    //console.log(i)



    this.calenderMode = "single";
    this.optionsMulti = {
      pickMode: this.calenderMode,
      // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
      disableWeeks: this.disabelDay,
    };
    this.dateRange = null;


  }

  async gopay() {
    console.log(this.BkgConPatientName, this.Email, this.Phoneno, this.finalPay);

    const loading1 = await this.loadingController.create({
      message: "Please wait we are redirecting you to the payment gateway"
    });
    await loading1.present();
    this.payment.getsessionid(this.BkgConPatientName, this.Email, this.Phoneno, this.finalPay).then(async (res: any) => {
      await loading1.dismiss();
      console.log(res, "response");
      console.log(this.selecteddates);

      if (res.status == '1') {
        this.paymentid = res.resultid;
        this.referenceid = res.sessionid;
        // }
        // else{
        //   console.log('payment faild');

        // }
        // })


        const loading = await this.loadingController.create({
          message: "Processing Your Payment Status"
        });
        await loading.present();
        console.log(this.storeFromDate)
        let apidata = JSON.stringify({
          "doctorId": this.doctorid,
          "patientId": this.currentMemberId,
          "packageId": this.packageid,
          "packageType": this.packagetype,
          "bookDate": this.searchDate,
          "fromDate": this.frombdate,
          "toDate": this.tobdata,
          "selecteddates": this.selecteddates,
          "fromTime": this.frmtime,
          "toTime": this.totime,
          "sessions": this.sessions,//this.selectedprogram.session,
          "fee": this.package_amount,
          "deal_amount": this.dealvalue,
          "deal_value": this.dealoption,
          "billing_amount": this.finalPay,
          "paymentStatus": "1",
          "location": this.F_address,//this.storeDocAdd,
          "paymentid": this.paymentid,
          "referenceid": this.referenceid,
          "locationid": this.location_id,
          "clinicid": this.clinic_id,
          "mamber_Approval": 'P',
          "physio_Approval": 'P'
        });
        this.services.postRequest("patientPhysioBooking", apidata).subscribe(async res => {
          console.log(res)
          await loading.dismiss();



          if (res.status == 1) {
            setTimeout(() => {
              this.playSound();
            }, 1000)
            this.router.navigate(['/payment', { paymentstatus: 1 }]);
          }
          else {
            this.presentToast(res.msg)
          }
        })
      }
      else if (res.status == '2') {
        this.AlertInfo("Payment Cancelled", 0)
      }
      else {
        console.log('paymentfailed');
        this.AlertInfo(this.addCall.title144, 0)
        // this.AlertInfo("Payment Failed", 0)
      }
    })


  }

  playSound() {
    let audio = new Audio();
    audio.src = "../assets/audio/tick.mp3";
    audio.load();
    audio.play();
  }

  // async openNdPlay(type, path, mode, thumnail) {
  //   let popover = await this.modalCtrl.create({
  //     component: MediapopupPage,
  //     componentProps: {
  //       Type: type,
  //       Path: path,
  //       ThumNail: thumnail
  //     },
  //     cssClass: 'media-popup',
  //   });
  //   return await popover.present();
  // }

  async openNdPlay(type: any, path: any, mode: any, thumbnail: any) {
    debugger
    if (this.storedPath === path) {
        this.showPopover(type, path, thumbnail);
    } else {
        this.storedPath = path;
        this.showPopover(type, path, thumbnail);
    }
  }
  
  private async showPopover(type: any, path: any, thumbnail: any) {
    debugger
    const popover = await this.modalCtrl.create({
        component: MediapopupPage,
        componentProps: {
            Type: type,
            Path: path,
            ThumNail: thumbnail,
        },
        cssClass: 'media-popup',
    });
    await popover.present();
  }
  scroll() {
    this.content.scrollToBottom(1000);
  }

  package_amount: any;
  working_days: any;
  package_details: any;
  async select_program() {
    this.showcal = false;
    // this.scroll();
    this.slotindex = null;
    console.log("select program", this.program);



    let alert = await this.modalCtrl.create({
      component: PhysioProgramPage,
      cssClass: 'service-model1',
      componentProps: {
        selectprogram: this.program
      }
    });
    alert.onDidDismiss().then((data) => {
      setTimeout(() => {
        this.scroll();
      }, 500);
      console.log(data)
      console.log(data.data)
      console.log(data.data.selected_program)


      if (data.data.selected_program != null) {
        console.log("+++++++++++++++++++++");

        this.selectedprogram = data.data.selected_program;
        this.programname = this.selectedprogram.package_name;
        this.packageid = this.selectedprogram.package_id;
        this.timeslots = this.selectedprogram.slot;
        console.log(this.timeslots);

        this.working_days = this.selectedprogram.working_days
        this.clupWorkingHr(this.working_days);
        this.dealoption = this.selectedprogram.deal_options;
        this.dealvalue = this.selectedprogram.deal_amount;
        this.totalAmount = this.selectedprogram.fee;
        this.sessions = this.selectedprogram.session;
        this.package_amount = this.selectedprogram.fee;
        this.package_details = this.selectedprogram.package_details

        if (this.dealoption == "Amount") {
          this.dealType = "KWD";
          this.finalPay = Number(this.totalAmount) - Number(this.dealvalue);
        } else if (this.dealoption == "Percentage") {
          this.dealType = "%";
          this.finalPay = Number(this.totalAmount) - (Number(this.totalAmount) * Number(this.dealvalue)) / 100;
        } else {
          this.finalPay = this.totalAmount;
        }

        this.calenderMode = "single";
        this.optionsMulti = {
          pickMode: this.calenderMode,
          // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
          disableWeeks: this.disabelDay,
        };
      }



    });
    await alert.present();
  }
  bookingListPage() {
    this.pageNo = 1;
    this.EmptyData = null;
    this.storeDocBookingList = [];
    this.showAppointmentListPage();
  }


  async showAddMemberPage() {
    const modal = await this.modalCtrl.create({
      component: AddmemPage,
      cssClass: 'Add-Member-Page',
      componentProps: {
        getMemName: "",
        getMemGender: "",
        getMemReletion: "",
        getMemHeight: "",
        getMemWeight: "",
        getMemMobileNo: "",
        membDOB: "",
        getMemDob: "",
        memProImg: ""
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        console.log(res);
        if (res.data.from == 2) {
          this.getPatientBasicDetails();
        }
      });
    return await modal.present();
  }

  viewBookingHisInfo(item) {

    console.log(item)
    this.presentView = 'historyviewBookingInfoPage';
    // this.backValue = 'bookingHisListPage'
    this.viewBookingDetail(item, 'historyviewBookingInfoPage')
    console.log(item)
  }

  reshedule: any

  
  changeMySchedule() {

    // if(this.storeRescheduleDate == this.storeRescheduleAltDate){
      // 
    console.log(this.showreschedulrdate)
    console.log(this.storeRescheduleAltDate.fullDate);
    if (this.showreschedulrdate == this.storeRescheduleAltDate.fullDate) {
      this.presentToast("These dates are already rescheduled.");

    }
    else if(this.storeRescheduleDate.formatedDate != null) {
      // 
      let apiData = JSON.stringify({

        "fromDate": this.storedetails.from_date,
        "toDate": this.storedetails.to_date,
        "fromTime": this.storedetails.from_time,
        "toTime": this.storedetails.to_time,
        "bookingId": this.storedetails.bookingId,
        "doctorId": this.storedetails.doctor_id,
        "patientId": this.storedetails.patient_id,
        "daysToReschedule": [
          {
            "toBeRescheduleDate": this.storeRescheduleDate.formatedDate,
            "rescheduledDate": this.storeRescheduleAltDate.formatedDate
          }
        ]
      })
      this.reshedule = this.services.postRequest("patientPhysioBookingSpecificDateReschedule", apiData).subscribe(res => {
        let result = res.data[0]
        if (result.msg == "Physio Rescheduled successfully!") {
          // this.AlertInfo("Physiotherapy Rescheduled Successfully", result.status);
          this.AlertInfo(this.addCall.title506, result.status);
          this.showBookingListPage();
        }
        else {
          this.presentToast(result.msg);
        }
      })
    }
    else{
      console.log('no reschedule')
    }
    // }

  }
  repearreview: any;
  repeat_thePackage: any;
  storerept_details: any;
  Distance: any;
  temp_pack_id: any;
  repeatBooking(item, i) {
    console.log(item);
    this.showbook = false;
    this.slotindex = null;
    console.log(this.historyList[i].package_is_active)
    if (this.historyList[i].package_is_active == 0 || this.historyList[i].package_is_active == 'false') {
      // this.presentView = "listCategory1"
      // this.showListCatPage()
      console.log("check")
    }
    else {
      console.log("check1")

      let bookingid = item.bookingId;
      let doctorid = item.doctor_id;
      this.temp_pack_id = item.packageid;
      this.location_id = item.location_id;
      this.clinic_id = item.clinic_id;
      console.log("check repeat ");
      this.presentView = 'repeat';
      this.backValue = 'bookingHisListPage';
      let apiDate1 = JSON.stringify({
        "packageid": this.temp_pack_id,
        "bookingid": bookingid,
        // "doctorid" : doctorid,
        // "lat": "8.331080",
        // "long": "77.172989"
      })
      this.repeat_thePackage = this.services.postRequest("getparticularPhysioBookingrepeatDetails", apiDate1).subscribe(res => {
        console.log(res.data[0])

        if (res.data[0].package_status == 1) {
          this.doctorid = doctorid;
          this.specialityId = res.data[0].specialty;
          this.packagetype = res.data[0].packageType;
          this.getPrtclrPhysioDocDetails();
          this.presentView = 'physioProfileRepeatInfo';
          this.backValue = 'bookingHisListPage';
          this.showOfferCardPage = true;
        }
        else {
          this.presentView = "listCategory1"
          this.showListCatPage()
        }





        //   this.storerept_details = res.data[0]
        //   this.revArr = JSON.parse(this.storerept_details.review_comment);
        //   this.getMedia(doctorid);
        //   this.programname = this.storerept_details.package_name;
        //   this.timeslots = this.storerept_details.slot;
        //   this.sessions = this.storerept_details.session;
        //   this.doctorid =this.storerept_details.id;
        //   //this.frmtime =this.storerept_details;
        //  // this.selecteddates=this.storerept_details;
        //  this.storeDocAdd = this.storerept_details.vendor_location;
        //   this.Distance =  this.storerept_details.Distance
        //   this.packageid=this.storerept_details.package_id;
        //   this.working_days = this.storerept_details.working_days
        //   this.clupWorkingHr( this.storerept_details.working_days );
        //   this.storeDocName = this.storerept_details.vendor_name;
        //   this.package_amount = this.storerept_details.fee;
        //   let deal = JSON.parse(this.storerept_details.dealDetails);

        //   this.dealoption = deal.deal_options;
        //   this.dealvalue = deal.deal_amount;
        //   this.totalAmount = this.package_amount;


        //   if(this.dealoption == "Amount") {
        //     this.dealType = "KWD";
        //     this.finalPay = Number(this.totalAmount) - Number(this.dealvalue);
        //   } else if(this.dealoption == "Percentage") {
        //     this.dealType = "%";
        //     this.finalPay =Number(this.totalAmount) - (Number(this.totalAmount) * Number(this.dealvalue)) / 100;
        //   } else {
        //     this.finalPay = this.totalAmount;
        //   }

        //   console.log(deal)
        //    console.log(this.storerept_details.package_id)
        //   console.log(this.timeslots)
        //   this.calenderMode = "single";
        //    this.optionsMulti = {
        //       pickMode: this.calenderMode,
        //       weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        //       disableWeeks: this.disabelDay,
        //     };


      })
    }
  }




  async viewMore(frm: any, cname: any) {


    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        showselectdate: this.change_formated_dates,
      },
      cssClass: cname,
    })
    return await popover.present()
  }


  isElementInViewPort(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  async playMedia() {
    try {
      await this.currentPlaying?.play();
      console.log("Played");
    } catch (err) {
      await this.currentPlaying?.pause();
      console.log("Paused - ", err);
      this.didScrollEvent(event);
    }
  }


  didScrollEvent(event) {
    console.log("check1");
    try {
      if (this.currentPlaying && this.isElementInViewPort(this.currentPlaying)) {

        return;
      } else if (this.currentPlaying && !this.isElementInViewPort(this.currentPlaying)) {
        this.currentPlaying.pause();
        this.currentPlaying = null;
        console.log("check1");
      }
      let temp: ElementRef<any>;
      this.vdoPlayer.forEach(player => {
        if (this.currentPlaying) {
          return;
        }
        const nativeElement = player.nativeElement;
        const inView = this.isElementInViewPort(nativeElement);

        if (inView) {
          this.currentPlaying = nativeElement;
          this.playMedia();
          temp = player;
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  pausePlay() {
    console.log(this.currentPlaying);

    let _obj = this;
    console.log("clicked");
    if (this.currentPlaying) {
      this.currentPlaying?.pause();
      this.currentPlaying = null;
    } else if (!this.currentPlaying) {
      this.vdoPlayer.forEach(player => {
        const nativeElement = player.nativeElement;
        const inView = this.isElementInViewPort(nativeElement);
        if (inView) {
          this.currentPlaying = nativeElement;
          this.currentPlaying.muted = true;
          const playPromise = _obj.currentPlaying.play();
          if (playPromise !== undefined) {
            playPromise.then(res => {
              console.log("played");
            })
              .catch(err => {
                this.currentPlaying?.pause();
                console.log("Paused - ", err);
              });
          }
        }
      });
    }
  }



  ratingSort() {
    this.storePhysiotherapyDocList = [];
    this.ratingSorting = true
    if (this.ratingBasedSortingOrder == "ASC") {
      this.ratingBasedSortingOrder = "DESC"
      console.log(this.ratingBasedSortingOrder);

    }
    else if (this.ratingBasedSortingOrder == "DESC") {
      this.ratingBasedSortingOrder = "ASC"
      console.log(this.ratingBasedSortingOrder);
    }
    this.showListPhysiotherapy(this.specialityId, this.specialityName);
  }



  async griVidcall(roomid, patientname, data) {

    console.log(roomid, patientname)


    await this.common.setVideocallUrl(data.doc_vc_room, data.appointment_time, data.duration);
    //  if (this.common.getTimeDiffernce(data.from_time, data.from_date) == 'valid') {
    this.videocall.joinJitsiMeeting(roomid, patientname, "","");
    // };
  }

  async showaddress(address, myEvent) {
    console.log('checkout address');

    let popover = await this.popoverController.create({

      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: "doctorBKFC"

      },
      translucent: true,
      cssClass: 'offrMod'
    });
    popover.onDidDismiss()
    return await popover.present();


  }


  async opensortpage() {
    this.pageNo = 1;
    const alert = await this.modalCtrl.create({

      component: RatingSortpagePage,
      showBackdrop: true,
      cssClass: 'rating_sort_page',
      backdropDismiss: false,
      componentProps: {
        frm: 'physiotherapy'
      }
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
      console.log(data.data.orderWise, 'and', data.data.orderby);
      if (data.data.orderby == 'Rating') {
        this.storePhysiotherapyDocList = [];
        this.ratingSorting = true
        this.distanceBasedSorting = false;
        this.ratingBasedSortingOrder = data.data.orderWise,
          this.showListPhysiotherapy(this.specialityId, this.specialityName);
      }
      else if (data.data.orderby == 'Deal') {

      }
      else if (data.data.orderby == 'Distance') {
        this.storePhysiotherapyDocList = [];
        this.ratingSorting = false;
        this.distanceBasedSorting = true;
        this.distanceBasecSortingOrder = data.data.orderWise;
        this.showListPhysiotherapy(this.specialityId, this.specialityName);
      }

    })


    await alert.present();
  }






  userapprove_Status: any = 0;
  Doctorapprove_Status: any = 0;
  id: any = "vdo";
  Type: any;
  Path: any;
  ThumNail: any;

  async vc_permission(bookingid, memberapproval, physioapproval) {
    console.log(bookingid, memberapproval, 'memberApproval', physioapproval, "physioapproval");

    if (memberapproval == 'R' || memberapproval == 'P' && (physioapproval == 'R' || physioapproval == 'P')) {
      const alert = await this.modalCtrl.create({
        component: PopupalertPage,
        cssClass: 'class_alert',
        backdropDismiss: false,
        componentProps: {
          'msg': 'Accept to view your recording',
          'sts': 6,
          'frm': 'check vc permission'
        }
      });

      alert.onDidDismiss().then((data) => {
        console.log(data);
        if (data.data == 'yes') {
          this.userapprove_Status = 'A'
        }
        else {
          this.userapprove_Status = 'R'
        }


        let apiData = JSON.stringify({
          "bookingId": bookingid,
          "approvalStatus": this.userapprove_Status,
          "type": "Member_Physiotherapy"
        });
        this.services.postRequest("updateVCApprovalStatus", apiData).subscribe(res => {
          console.log(res);
          this.showBookingHisListPage();
        });

      })

      await alert.present();
    }


    if (memberapproval == 'A' && (physioapproval == 'R' || physioapproval == 'P')) {
      // this.AlertInfo('Doctor not approved to view your VC recording ', 2)
      this.AlertInfo(this.addCall.title452, 2)
    }

    if (memberapproval == 'A' && physioapproval == 'A') {
      this.presentView = "vc_video";
      this.headerValue = 'VC Recording';
      this.backValue = 'bookingHisListPage';
      this.Type = 'Video';
      this.Path = 'http://157.241.0.129:8000//uploads/file-1655215322863Video2_Trim.mp4';
      this.ThumNail = 'http://157.241.0.129:8000//uploads/file-1655215303239Video2_Moment.jpg';

    }

  }





  goBack(value) {
    console.log("backValue=>", value);
    this.isConfirmed = false
    switch (value) {
      case "goHome": {
        this.router.navigate(['/tabs/home']);
        this.SearchCat = "";

        break;
      }
      case "listCategory1": {
        this.showListCatPage();
        this.SearchContent = "";
        this.packagetype = 2;
        this.scenter = 'homeList';
        this.SearchCat = "";
        this.ratingSorting = false;
        this.distanceBasedSorting = false;
        this.storePhysiotherapyDocList = [];
        console.log(this.storePhysiotherapyDocList.length);
        this.EmptyData = null
        if (this.getphysiolist) {
          this.getphysiolist.unsubscribe();
        }
        // this.scrollEvent=null;
        break;
      }
      case "goPhysioListPage": {
        this.storePhysiotherapyDocList = [];
        this.showcal = false;
        this.dateRange = null;
        this.disabelDay = [];
        this.program = null;
        this.presentView = "listPhysiotherapy";
        this.backValue = "listCategory1";
        this.slotindex = null;
        this.showListPhysiotherapy(this.specialityId, this.specialityName);
        // this.scrollEvent=null;
        break;
      }
      case "goPhysioProCardPage": {
        this.presentView = "physioProfileInfo";
        this.headerValue = this.storeDocName;
        if (this.backflrepeat == true) {
          this.backValue = "bookingHisListPage";
          console.log(this.backflrepeat);
        }
        else {
          console.log(this.backflrepeat);

          this.backValue = "goPhysioListPage";
        }

        this.showOfferCardPage = true;
        this.showCalenderPage = false;
        break;
      }
      case "goPhysioSlctDatepage": {
        this.presentView = "physioProfileInfo";
        this.headerValue = this.storeDocName;
        this.backValue = "goPhysioProCardPage";
        this.showOfferCardPage = false;
        this.showCalenderPage = true;
        break;
      }
      //this.backflrepeat = 'true';
      case "goBookingListPage": {
        console.log("check1")
        this.presentView = "bookingListPage";
        this.headerValue = "Appoinments";
        this.backValue = "listCategory1";
        this.showslt_dates = [];
        this.showslt_dayes = [];
        this.compltedays = [];
        this.intersection = [];
        this.showBookingListPage();
        break;
      }
      case "bookingHisListPage": {
        this.particularPhysioDocDetails = null;
        this.calenderMode = "single";
        this.slotindex = null;
        this.dateRange = null;
        this.disabelDay = [];
        this.storerept_details = [];
        this.storeWorkingDayIndex = [];
        this.showBookingHisListPage();
        this.selectedprogram = null;
        this.showcal = false;
        this.slotindex = null;
        break;
      }
      case "goViewBookingPage": {
        this.compltedays = [];
        this.intersection = [];
        this.showslt_dates = [];
        this.presentView = "viewBookingInfoPage";
        // this.headerValue = "View Booking";
        this.headerValue = this.addCall.title133;
        this.backValue = "goBookingListPage";
        break;
      }
    }

  }

  
  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  openTerms() {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Nurse');
  
    this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        response => {
          if (response && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
            const decryptedData = this.decryptContent(this.terms_and_condition_file);
            console.log("Decrypted data:", decryptedData);
        
            if (!decryptedData) {
              throw new Error('Decryption failed');
            }
        
            const content = htmlToPdfmake(decryptedData);
            console.log("PDF content:", content);
        
            if (!content || !Array.isArray(content)) {
              throw new Error('Invalid content structure');
            }
        
            const documentDefinition = {
              content: content,
              styles: {
                header: { 
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
                  margin: [40, 0, 40, 0],
                },
                footerText: {
                  fontSize: 10,
                },
              },
              header: (currentPage, pageCount, pageSize) => {
                const modified_on =  new Date();
                return {
                  text: ``,
                  alignment: 'left',
                  style: 'header',
                  color: '#510F30',
                  margin: [30, 40, 0, 0],
                };
              },
              footer: (currentPage, pageCount, pageSize) => {
        
                const modified_on =  new Date();
        
                return {
                  margin: [40, 40, 40, 40],
                  columns: [
                    {
                      stack: [,
                        {
                          text: `Page ${currentPage}/${pageCount}`,
                          alignment: "right",
                          color: "#510F30",
                          style: "footerText",
                        },
                      ],
                    },
                  ],
                };
              },
              pageMargins: [40, 70, 40, 180],
            };
            pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
              console.log("PDF Blob:", blob);
              try {
                const localBlob = new Blob([blob], { type: 'application/pdf' });
                const fileName = `report_${new Date().getTime()}.pdf`;
                await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
                  .then((fileEntry) => {
                    console.log("File entry:", fileEntry);
                    this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
                      .then(() => console.log('File is opened'))
                      .catch(e => console.log('Error opening file', e));
                  })
                  .catch(e => console.log('Error writing file', e));
              } catch (error) {
                console.error('Error uploading file', error);
              }
            });

          } else {
            console.error('Unexpected response format:', response);
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }

}
function getDate() {
  throw new Error('Function not implemented.');
}

